import { round } from '@deltasierra/utilities-math';
import { CurrencyCode, CurrencyNumber } from '../../common';
import { AdWordsAdEntityFields, AdWordsEntityIdentityFields, HasConversionTypeName } from './common';

export interface ConversionsMetrics {
    currencyCode: CurrencyCode | null;
    conversions: number;
    cost: CurrencyNumber;
    totalConversionValue: CurrencyNumber;
}

export interface ConversionsLocationStats extends ConversionsMetrics {
    locationId: number;
    conversionTypeTotals: ConversionsConversionTypeStats[];
}

export interface ConversionsConversionTypeStats extends ConversionsMetrics, HasConversionTypeName {
    entityTotals: ConversionsEntityStats[];
}

export interface ConversionsEntityStats extends ConversionsMetrics, AdWordsEntityIdentityFields {}

export interface ConversionsAdEntityStats extends ConversionsEntityStats, AdWordsAdEntityFields {}

export type ConversionsStats =
    | ConversionsAdEntityStats
    | ConversionsConversionTypeStats
    | ConversionsEntityStats
    | ConversionsLocationStats;

export function isConversionsLocationStats(stats: ConversionsStats): stats is ConversionsLocationStats {
    return !!(stats as Partial<ConversionsLocationStats>).conversionTypeTotals;
}

export function isConversionsConversionTypeStats(stats: ConversionsStats): stats is ConversionsConversionTypeStats {
    return !!(stats as Partial<ConversionsConversionTypeStats>).entityTotals;
}

export function isConversionsAdEntityStats(stats: ConversionsStats): stats is ConversionsAdEntityStats {
    const pref = (stats as Partial<ConversionsAdEntityStats>).devicePreference;
    return !!pref || pref === '';
}

export function getCostPerConversion(cost: CurrencyNumber, conversions: number): CurrencyNumber {
    return round(cost / conversions, 2);
}
